import { DraftWaypointStatus } from '@caresend/types';
import { hasStatus } from '@caresend/utils';
import { routeToLocation } from '../../helpers/builders.js';
import { getPrevRoute, getMostRecentInHistory } from '../../helpers/initRouter.js';
import { homeRoute, officeVisitsRoute } from '../locations.js';
import { SchedulingFlowRouteName } from '../schedulingFlow/model.js';
import { VisitsPageRouteName } from './model.js';
import { isPatientUser } from '../../../store/helpers.js';

const getDraftWaypointDetailsBackLocation = (draftWaypoint) => {
    var _a, _b, _c, _d, _e;
    const isPatientApp = isPatientUser();
    const prevRoute = getPrevRoute();
    // If the user arrived at this page by clicking "View new visit" on a
    // rescheduled visit, send them back to the rescheduled visit.
    if (((_a = prevRoute.value) === null || _a === void 0 ? void 0 : _a.name) === VisitsPageRouteName.DRAFT_WAYPOINT_DETAILS) {
        const { rescheduledFromID } = draftWaypoint !== null && draftWaypoint !== void 0 ? draftWaypoint : {};
        const prevVisitPageID = (_c = (_b = prevRoute.value) === null || _b === void 0 ? void 0 : _b.params) === null || _c === void 0 ? void 0 : _c.draftWaypointID;
        if (rescheduledFromID && prevVisitPageID === rescheduledFromID) {
            return routeToLocation(prevRoute.value);
        }
    }
    const backRoute = (_d = getMostRecentInHistory([
        VisitsPageRouteName.VISITS_PAGE,
        'Orders', // Pro OFFICE_ORDERS route
    ])) !== null && _d !== void 0 ? _d : {
        name: VisitsPageRouteName.VISITS_PAGE,
    };
    let query = {};
    const isPending = hasStatus(draftWaypoint, DraftWaypointStatus.PENDING);
    if ((draftWaypoint === null || draftWaypoint === void 0 ? void 0 : draftWaypoint.isDraftOrder) !== undefined || isPending) {
        query = { ...query, actionRequired: 'true' };
    }
    if ((draftWaypoint === null || draftWaypoint === void 0 ? void 0 : draftWaypoint.isDraftOrder) === undefined && !isPending) {
        query = { ...query, actionRequired: 'false' };
    }
    const now = Date.now();
    if ((_e = draftWaypoint === null || draftWaypoint === void 0 ? void 0 : draftWaypoint.date) === null || _e === void 0 ? void 0 : _e.timestamp) {
        const finalizedTimestamp = draftWaypoint.date.timestamp;
        query = { ...query, past: finalizedTimestamp < now ? 'true' : 'false' };
    }
    if ((backRoute === null || backRoute === void 0 ? void 0 : backRoute.name) === VisitsPageRouteName.VISITS_PAGE) {
        return isPatientApp
            ? homeRoute()
            : {
                ...officeVisitsRoute(),
                query: { ...backRoute.query, ...query },
            };
    }
    if ((backRoute === null || backRoute === void 0 ? void 0 : backRoute.name) === SchedulingFlowRouteName.SCHEDULING_FLOW_VISIT_OVERVIEW) {
        return isPatientApp ? homeRoute() : officeVisitsRoute();
    }
    return routeToLocation(backRoute);
};

export { getDraftWaypointDetailsBackLocation };
